import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewEncapsulation,
  input
} from "@angular/core";
import { ThemePalette } from "@angular/material/core";
import { MatRadioButton } from "@angular/material/radio";

@Component({
  selector: "app-radio-button",
  templateUrl: "./radio-button.component.html",
  encapsulation: ViewEncapsulation.None,
  imports: [MatRadioButton],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RadioButtonComponent implements OnInit {
  value = input.required<string>();
  checked = input<boolean>(false);
  size = input<"xl" | "md" | "sm" | undefined>();
  color = input<ThemePalette | undefined>();

  constructor() {}

  ngOnInit(): void {}
}
